<template>
  <div ref="faqRef" class="faq">
    <div v-for="(faq, index) in faqs" :key="index" class="faq_card">
      <div class="faq_header" @click="toggleFaq(index)">
        <div class="faq_question">
          {{ faq.question }}
        </div>
        <div class="toggle" :class="{ 'is-open': !faq.isOpen }">
          <ThePlus v-if="!faq.isOpen" />
          <TheMinus v-else />
        </div>
      </div>
      <div
        class="faq_content"
        :class="{ 'is-open': faq.isOpen }"
        :style="{ maxHeight: faq.isOpen ? getContentHeight(index) : '0px' }"
      >
        <div class="faq_answer" v-html="faq.answer"></div>
        <a
          class="faq_link pointer"
          href="https://t.me/geekstore_support"
          style="text-decoration: none"
        >
          {{ faq.link }}
        </a>
      </div>
    </div>
<!--    <div class="support-container">-->
<!--      <p class="support-text">Не нашли ответа на свой вопрос?</p>-->
<!--      <a href="#" class="support-link">-->
<!--        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 32 32" xml:space="preserve"><path d="M9.467 29.134H5.078A4.082 4.082 0 0 1 1 25.056V17.91a4.082 4.082 0 0 1 4.078-4.078h4.389a1 1 0 0 1 1 1v13.3a1 1 0 0 1-1 1zM5.078 15.833A2.081 2.081 0 0 0 3 17.911v7.145c0 1.145.933 2.078 2.078 2.078h3.389V15.833H5.078zM26.922 29.134h-4.389a1 1 0 0 1-1-1V14.833a1 1 0 0 1 1-1h4.389A4.082 4.082 0 0 1 31 17.911v7.145a4.082 4.082 0 0 1-4.078 4.078zm-3.389-2h3.389A2.081 2.081 0 0 0 29 25.056V17.91a2.081 2.081 0 0 0-2.078-2.078h-3.389v11.3z"/><path d="M9.467 29.134H5.078A4.082 4.082 0 0 1 1 25.056V17.91a4.082 4.082 0 0 1 4.078-4.078h4.389a1 1 0 0 1 1 1v13.3a1 1 0 0 1-1 1zM5.078 15.833A2.081 2.081 0 0 0 3 17.911v7.145c0 1.145.933 2.078 2.078 2.078h3.389V15.833H5.078zM26.922 29.134h-4.389a1 1 0 0 1-1-1V14.833a1 1 0 0 1 1-1h4.389A4.082 4.082 0 0 1 31 17.911v7.145a4.082 4.082 0 0 1-4.078 4.078zm-3.389-2h3.389A2.081 2.081 0 0 0 29 25.056V17.91a2.081 2.081 0 0 0-2.078-2.078h-3.389v11.3z"/><path d="M28.074 14.833C27.484 8.688 22.296 3.867 16 3.867S4.515 8.688 3.926 14.833H7.69C8.26 10.753 11.765 7.6 16 7.6s7.738 3.153 8.31 7.233h3.764z"/></svg>-->
<!--        Напишите нам в поддержку-->
<!--      </a>-->
<!--    </div>-->
  </div>
</template>

<script setup lang="ts">
import { ref, nextTick, onMounted } from "vue";
import ThePlus from "@/assets/icons/plus.svg";
import TheMinus from "@/assets/icons/minus.svg";
import { useYandexMetrika } from 'yandex-metrika-vue3'

const yandexMetrika = useYandexMetrika()
const faqRef = ref<null|HTMLDivElement>(null)
const webapp = window.Telegram.WebApp;

interface FAQ {
  question: string;
  answer: string;
  link: string;
  isOpen: boolean;
}

const faqs = ref<FAQ[]>([
  {
    question: "У меня нет нужной игры в Steam",
    answer:
      "Если не нашли нужную игру в поисĸе магазина Steam, напишите оператору – он поможет Вам с этим!",
    link: "Связаться с оператором",
    isOpen: false,
  },
  {
    question: "Как сменить регион в аккаунте?",
    answer:
      "Если вам нужно изменить регион, обратитесь к оператору – он подскажет, как это сделать. ",
    link: "Связаться с оператором",
    isOpen: false,
  },
  {
    question: "Не понимаю, как пользоваться ботом?",
    answer:
      "Не переживайте! Просто напишите оператору, и он объяснит все шаги. ",
    link: "Связаться с оператором",
    isOpen: false,
  },
  {
    question: "Каĸ пополнить аĸĸаунт из Крыма, Лугансĸа, Донецĸа?",
    answer: `
1. Завершите все аĸтивные сессии Steam на ПК и в браузере.<br/>
2. Переведите мобильное устройство с аутентифиĸатором Steam в авиарежим (если
находитесь в одном из этих регионов).<br/>
3. Используя VPN с российсĸим IP (желательно Мосĸва или Санĸт-Петербург),
авторизуйтесь в Steam через браузер. Мобильный аутентифиĸатор сможет дать ĸод для
входа даже в авиарежиме.<br/>
4. Подождите 5 минут после успешной авторизации и попробуйте пополнить счёт на
нашем сайте.<br/>
5. Не заходите в аĸĸаунт, поĸа не получите письмо от Steam об успешной операции.
`,
    link: "",
    isOpen: false,
  },
  {
    question: "Разрешенные страны для пополнения",
    answer: `
Списоĸ доступных регионов Steam для пополнения:
<br/><br/>
CIS (USD): Армения, Азербайджан, Беларусь, Кыргызстан, Молдова, Таджиĸистан,<br/>
Турĸменистан, Узбеĸистан<br/>
CIS (RUB): Россия<br/>
CIS (KZT): Казахстан<br/>
EUROPE (USD): Грузия<br/>
EUROPE (UAH): Уĸраина<br/>
<br/>
Для аĸтуального списĸа регионов и ĸомиссий, пожалуйста, обратитесь ĸ приложению.
`,
    link: "",
    isOpen: false,
  },
  {
    question: "У меня новый или ранее НЕ пополнявшийся аккаунт",
    answer: `
Если совершаете первое пополнение кошелька Steam, то валюта аккаунта <u>может</u> измениться на одну из списка (₸, $ и другие). В этом случае страна аккаунта тоже будет изменена автоматически как и цены на внутренние товары будут пересчитываться в валюту аккаунта (₸, $ и другие), а не ₽ (рубли). Учтите это при пополнении!
Таким образом можно даже попробовать изменить регион своего аккаунта.
</br>
</br>

Чтобы этого избежать нужно добавить в библиотеку бесплатную игру обязательно с телефона. Тогда за Вами закрепится нужный регион.
    `,
    link: "",
    isOpen: false,
  },
  {
    question: "Мне пришла сумма меньше",
    answer: "При пополнении Вашего кошелька Steam проходит обязательная конвертация из $ в валюту Вашего аккаунта, по внутреннему курсу Steam. Иногда сумма может отличаться на 1-5% от указанной (как в большую так и в меньшую сторону), по этому в калькуляторе выше указана ~примерная сумма пополнения.",
    isOpen: false,
    link: ""
  },
  {
    question: "Не пришли деньги на мой кошелёк Steam",
    answer: `
   
    Если Вы указали верно ЛОГИН (это НЕ никнейм) и баланс Вашего аккаунта - рубли (₽), тенге (₸) или доллары ($), пополнение происходит моментально.
    Если Вам не поступили средства на баланс в течение часа, пожалуйста, обратитесь к оператору.
      `,
    link: "Связаться с оператором",
    isOpen: false,
  },
  {
    question: "Возврат средств",
    answer: `
 
    Если Вы проигнорировали требования к аккаунту и все же попытались отправить себе средства, то они не дойдут. В случае если регион аккаунта Steam не входит в состав СНГ стран - возврат невозможен по причине невозможности возврата денежных средств платёжной системой и Steam шлюзом. Если Вы не уверены в корректности своих данных, попробуйте пополнить свой аккаунт на маленькую сумму или уточните информацию у оператора.
      `,
    link: "Связаться с оператором",
    isOpen: false,
  },
  {
    question: "Где взять промо-код?",
    answer: `
 
   Подпишись на наш <a style="text-decoration: underline;color: #0088cc;" href="https://t.me/geekstore">Telegram</a> , чтобы не пропустить новые промокоды и участвовать в розыгрышах!
      `,
    link: "",
    isOpen: false,
  },
  {
    question: "Документы",
    answer: `
    <a class="underline agreement-link" href="/Пользовательское соглашениe.pdf">Пользовательское соглашение</a><br><br>
    <a class="underline agreement-link" href="/Политика конфиденциальности.pdf">Политика конфиденциальности</a>
      `,
    link: "",
    isOpen: false,
  },
]);

const toggleFaq = (index: number, scroll=false) => {
  faqs.value[index].isOpen = !faqs.value[index].isOpen;

  // --- ОТПРАВКА СОБЫТИЯ FAQ_OPEN ---
  if (faqs.value[index].isOpen) {
    yandexMetrika.reachGoal('FAQ_OPEN');
  }

  if (scroll && faqs.value[index].isOpen) {
    nextTick(() => {
      const faqElements = document.querySelectorAll(".faq_card");
      const targetElement = faqElements[index];
      targetElement.classList.remove('_highlight');
      targetElement.classList.add('_highlight');

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  }
};

const getContentHeight = (index: number) => {
  return faqs.value[index].isOpen ? "500px" : "0px";
};
defineExpose({ toggleFaq, getLastIndex: () => faqs.value.length - 1 });

onMounted(() => {
  faqRef.value.addEventListener('click', e => {
    const target = e.target as HTMLDivElement;
    const link = target.closest('.agreement-link');
    if (link && webapp) {
      webapp.openLink(link.href);
      e.preventDefault();
    }
  })
})


</script>

<style scoped>
.faq {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.faq_card {
  @apply pb-4 border-b border-black border-opacity-10 dark:border-white dark:border-opacity-10 last:border-none last:pb-0;
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
}

.faq_card._highlight::before {
  box-sizing: content-box;
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  padding: 8px 8px 0 8px;
  transform: translate(-50%,-50%);
  border-radius: 16px;
  animation-iteration-count: 2;
  animation-duration: 1.5s;
  animation-direction: alternate;
  animation-name: highlight;
}

.faq_header {
  position: relative;
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.faq_question {
  @apply text-black dark:text-white dark:text-[13px] pr-10;
}

.faq_content {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  transform: translateY(-10px);
}

.faq_content.is-open {
  opacity: 1;
  transform: translateY(0);
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.faq_answer {
  @apply my-2 text-[11px] text-black text-opacity-80 dark:text-white dark:text-opacity-80;
}

.faq_link {
  @apply text-blue-light text-[11px];
}

.toggle {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}

.toggle.is-open {
  transform: rotate(90deg);
}
.support-container {
  width: 100%;
  text-align: center;
  padding: 16px;
  font-size: 16px;
  color: #b0b0b0;
  background: inherit;
  margin-top: 40px;
  font-family: Arial, sans-serif;
}

.support-text {
  font-size: 16px;
  color: #b0b0b0;
  margin-bottom: 8px;
}

.support-link {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: white;
  font-size: 18px;
  font-weight: bold;
}

.icon {
  font-size: 20px;
  margin-right: 8px;
  color: white;
}

@keyframes highlight {
  from {
    background-color: theme(colors.primary);
    opacity: 0;
  }
  to {
    background-color: theme(colors.primary);
    opacity: 0.5;
  }
}
</style>
